export default "__VITE_ASSET__BObzeSDf__"